import { createParser } from './create.js';
import config from '../syntax/config/parser.js';

export default createParser(config);
